/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Shaunt Kojabashian <shaunt@hbrisk.com>
 * Date: 8/16/26
 * Copyright All Rights Reserved
 */
import React from 'react';

/**
 * Renders the site-wide notice that Site Hazards is migrating to the SP3 Risk
 * Model Platform. Deliberately non-dismissible: existing assessments do not
 * carry over, so users need the export reminder on every visit.
 * @return {Object}
 */
const MigrationBanner = () => (
  <div className="migration-banner alert alert-warning" role="alert">
    <svg
      className="migration-banner-icon"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d={'M12 2.5c.53 0 1.02.28 1.29.74l9.5 16.25c.27.47.27 1.04 0 1.5-.27.47-.77.76' +
          '-1.29.76H2.5c-.52 0-1.02-.29-1.29-.76-.27-.46-.27-1.03 0-1.5l9.5-16.25c.27' +
          '-.46.76-.74 1.29-.74zm0 5.5a1.2 1.2 0 0 0-1.2 1.28l.35 5.1a.85.85 0 0 0 1.7' +
          ' 0l.35-5.1A1.2 1.2 0 0 0 12 8zm0 9a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z'}
      />
    </svg>
    <div className="migration-banner-message">
      <strong>Site Hazards is moving to the SP3 Risk Model Platform.</strong>
      {' '}
      We&rsquo;ll be reaching out to move your account over. Your existing SP3-SiteHazards
      assessments will not transfer &mdash; please export anything you want to keep before
      your account is moved.
    </div>
  </div>
);

export default MigrationBanner;
